import { OptionsApi } from '@core/swagger-client';
import { EmailListDetailPage } from '@online-webinar/management';
import { RouterType } from '@online-webinar/router';
import { titleName } from '../components/DocumentTitle/routeTitle';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/manage/email-lists/$id'].update({
        staticData: {
            title: {
                name: titleName(
                    ({ id }) => OptionsApi.emailLists.getDetail(id),
                    (list) => list.description,
                    'EmailLists.PageHeading'
                )
            }
        },
        component: authGuard(EmailListDetailPage, { isWhitelabel: true, canManageEmailLists: true })
    });
};
